import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";
import { NAV, CONTACT } from "@/lib/content";
import { LogoWordmark } from "@/components/common/Logo";

export const Footer = () => (
  <footer className="relative overflow-hidden border-t border-white/10 bg-[#0E0E10]" data-testid="site-footer">
    <div className="hatch-bg absolute inset-0 opacity-[0.35]" />
    <div className="container-px relative py-16">
      <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <LogoWordmark />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-zinc-400">
            Your India Expansion & GCC partner. We remove the complexity of building and
            operating teams in India so you can focus on growing your business.
          </p>
          <p className="mt-6 font-head text-lg font-semibold text-white">
            Ideas Hatch. Teams Grow. Businesses Scale.
          </p>
        </div>

        <div>
          <h4 className="kicker mb-5">Explore</h4>
          <ul className="space-y-3">
            {NAV.map((n) => (
              <li key={n.path}>
                <Link
                  to={n.path}
                  data-testid={`footer-link-${n.path === "/" ? "home" : n.path.slice(1)}`}
                  className="text-sm text-zinc-400 transition-colors hover:text-orange-400"
                >
                  {n.label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/stories" data-testid="footer-link-stories" className="text-sm text-zinc-400 transition-colors hover:text-orange-400">
                Stories
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="kicker mb-5">Get in touch</h4>
          <ul className="space-y-4 text-sm text-zinc-400">
            <li className="flex items-start gap-3"><Mail className="mt-0.5 h-4 w-4 text-orange-400" /> {CONTACT.email}</li>
            <li className="flex items-start gap-3"><Phone className="mt-0.5 h-4 w-4 text-orange-400" /> {CONTACT.phone}</li>
            <li className="flex items-start gap-3"><MapPin className="mt-0.5 h-4 w-4 text-orange-400" /> {CONTACT.address}</li>
          </ul>
          <Link to="/contact" data-testid="footer-cta" className="btn-ghost mt-7">
            Start Your India Journey <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
      </div>

      <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 text-xs text-zinc-500 sm:flex-row">
        <p>© {new Date().getFullYear()} Pixel-Hatch. All rights reserved. {CONTACT.region}.</p>
        <p className="font-mono">The HATCH Framework™ · From Vision to Victory.</p>
      </div>
    </div>
  </footer>
);
